var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m43.91,10.1c.6,0,1.17.23,1.6.66l8.04,8.04c.43.43.66.99.66,1.6v30.22c0,2.15-1.75,3.9-3.9,3.9H13.69c-2.15,0-3.9-1.75-3.9-3.9V14c0-2.15,1.75-3.9,3.9-3.9h30.22m0-3H13.69c-3.81,0-6.9,3.09-6.9,6.9v36.62c0,3.81,3.09,6.9,6.9,6.9h36.62c3.81,0,6.9-3.09,6.9-6.9v-30.22c0-1.39-.55-2.73-1.54-3.72l-8.04-8.04c-.99-.99-2.32-1.54-3.72-1.54h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "wasm-icon-fill",
    d: "m42.9,8.29h-21.81c-.9,0-1.62.73-1.62,1.62v10.39c0,.9.73,1.62,1.62,1.62h21.81c.9,0,1.62-.73,1.62-1.62v-10.39c0-.9-.73-1.62-1.62-1.62Zm-1.02,10.67c0,.54-.44.98-.98.98h-2.57c-.54,0-.98-.44-.98-.98v-7.71c0-.54.44-.98.98-.98h2.57c.54,0,.98.44.98.98v7.71Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "wasm-icon-fill",
    x: 14.96,
    y: 30.75,
    width: 34.07,
    height: 18.88,
    rx: 2.31,
    ry: 2.31
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconSave);
export default __webpack_public_path__ + "static/media/SDS_icon_Save.2fa74ff53288dbf3365c57a3fbef66ba.svg";
export { ForwardRef as ReactComponent };